import React, { Component } from 'react';
import './MyNFTs.css';
import * as encryptUtils from './encryptDecryptUtils';
import * as loggingUtils from './utils/loggingUtils';
import PlatformSidebar from './PlatformSidebar';
import Onboarding from './Onboarding.js';
import AddFunds from './AddFunds.js';
import ImportFromPassword from './ImportFromPassword';
import TransactionStatus from './TransactionStatus';
import { contractAddress, mainnetContractAddress, bondingCurveContractAddress, mainnetBondingCurveContractAddress } from "./config";
import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import Profile from './Profile';
import ListedNFT from './ListedNFT';
import UnlistedNFT from './UnlistedNFT';
const contract = require("./artifacts/contracts/The402NFT.sol/The402NFT.json");
const contract2 = require("./artifacts/contracts/BondingCurveNFT.sol/BondingCurveNFT.json");

let web3;
let usedContractAddress;
let usedContractAddressBondingCurve;
if(process.env.REACT_APP_IS_MAINNET !== "testnet") {
  web3 = createAlchemyWeb3(process.env.REACT_APP_ETHEREUM_WEBSOCKET_URL);
  usedContractAddress = mainnetContractAddress;
  usedContractAddressBondingCurve = mainnetBondingCurveContractAddress;
} else {
  web3 = createAlchemyWeb3(process.env.REACT_APP_GOERLI_WEBSOCKET_URL);
  usedContractAddress = contractAddress;
  usedContractAddressBondingCurve = bondingCurveContractAddress;
}

class MyNFTs extends Component {
  constructor(props) {
    super(props);
    this.getHeldAndListedNFTs = this.getHeldAndListedNFTs.bind(this);
    this.selectModal = this.selectModal.bind(this);
    this.setTransactionStatus = this.setTransactionStatus.bind(this);

    this.state = {
      isShowingUnlistedTab: true,
      address: null,
      modalShown: '',
      currentlyListedNFTs: [],
      heldNFTs: [],
      editionsListing: 0,
      listingPrice: 0,
      transactionStatus: "None"
    }
  }

  selectModal(modal) {
    this.setState({
      modalShown: modal,
    });
  }

  setTransactionStatus(status) {
    this.setState({
      transactionStatus: status,
    });
  }

  async getHeldAndListedNFTs() {
    let heldNFTs = await encryptUtils.getHeldNFTs(this.props.account.address);
    let currentlyListedNFTs = await encryptUtils.getCurrentlyListedNFTs(this.props.account.address);
    let listedEditionsByAuthUUIDAndProtocol = {}
    for(let i = 0; i < currentlyListedNFTs.length; i++) {
      let listedNFT = currentlyListedNFTs[i];
      if(listedNFT.authUUID in listedEditionsByAuthUUIDAndProtocol) {
        listedEditionsByAuthUUIDAndProtocol[listedNFT.authUUID + " " + listedNFT.protocol] += listedNFT.amount;
      } else {
        listedEditionsByAuthUUIDAndProtocol[listedNFT.authUUID + " " + listedNFT.protocol] = listedNFT.amount;
      }
    }
    for(let i = 0; i < heldNFTs.length; i++) {
      let heldNFT = heldNFTs[i];
      heldNFT.listableEditions = heldNFT.balance;
      if((heldNFT.authUUID + " " + heldNFT.protocol) in listedEditionsByAuthUUIDAndProtocol) {
        heldNFT.listableEditions -= listedEditionsByAuthUUIDAndProtocol[heldNFT.authUUID + " " + heldNFT.protocol];
      }
      heldNFTs[i] = heldNFT;
    }
    this.setState({
      currentlyListedNFTs,
      heldNFTs,
    });
  }

  async componentDidMount() {
    let self = this;
    const ppvContract = new web3.eth.Contract(contract.abi, usedContractAddress);
    const bondingCurveContract = new web3.eth.Contract(contract2.abi, usedContractAddressBondingCurve);
    ppvContract.events.MarketItemCreated().on("data", function(event) {
      if(self.props.account == null) {
        return;
      }
      let data = event.returnValues;
      if(data["seller"].toString().toLowerCase() !== self.props.account.address.toString().toLowerCase()) {
        return;
      }
      let heldNFTs = self.state.heldNFTs;
      for(let i = 0; i < heldNFTs.length; i++) {
        if(heldNFTs[i]["authUUID"] === data["authUUID"] && heldNFTs[i]["protocol"] === "the402") {
          heldNFTs[i]["listedEditions"] = parseInt(heldNFTs[i]["listedEditions"]) + parseInt(data["amount"]);
          heldNFTs[i]["listableEditions"] = parseInt(heldNFTs[i]["listableEditions"]) - parseInt(data["amount"]);
        }
      }
      self.setState({
        heldNFTs,
        transactionStatus: "List Complete",
      });
    }).on("error", function(event) {
      self.setState({
        transactionStatus: "Failed",
      })
    });
    bondingCurveContract.events.MarketItemCreated().on("data", function(event) {
      if(self.props.account == null) {
        return;
      }
      let data = event.returnValues;
      if(data["seller"].toString().toLowerCase() !== self.props.account.address.toString().toLowerCase()) {
        return;
      }
      let heldNFTs = self.state.heldNFTs;
      for(let i = 0; i < heldNFTs.length; i++) {
        if(heldNFTs[i]["authUUID"] === data["authUUID"] && heldNFTs[i]["protocol"] === "liquid") {
          heldNFTs[i]["listedEditions"] = parseInt(heldNFTs[i]["listedEditions"]) + parseInt(data["amount"]);
          heldNFTs[i]["listableEditions"] = parseInt(heldNFTs[i]["listableEditions"]) - parseInt(data["amount"]);
        }
      }
      self.setState({
        heldNFTs,
        transactionStatus: "List Complete",
      });
    }).on("error", function(event) {
      self.setState({
        transactionStatus: "Failed",
      })
    });

    let marketItems = await encryptUtils.getMarketItems();
    ppvContract.events.MarketItemDelisted().on("data", function(event) {
      let data = event.returnValues;
      let isForUser = false;
      for(let i = 0; i < marketItems.length; i++) {
        if(
          parseInt(marketItems[i]["marketItemId"]) === parseInt(data["marketItemId"]) &&
          marketItems[i]["protocol"] === "the402"
        ) {
          if(
            self.props.account != null &&
            marketItems[i]["sellerAddress"].toLowerCase() === self.props.account.address.toLowerCase()
          ) {
            isForUser = true;
          }
          marketItems.splice(i, 1);
          break;
        }
      }
      if(isForUser) {
        self.setState({
          marketItems,
          transactionStatus: "Delist Complete",
        });
      } else {
        self.setState({
          marketItems,
        });
      }
    }).on("error", function(event) {
      self.setState({
        transactionStatus: "Failed",
      });
    });
    bondingCurveContract.events.MarketItemDelisted().on("data", function(event) {
      let data = event.returnValues;
      let isForUser = false;
      for(let i = 0; i < marketItems.length; i++) {
        if(
          parseInt(marketItems[i]["marketItemId"]) === parseInt(data["marketItemId"]) &&
          marketItems[i]["protocol"] === "liquid"
        ) {
          if(
            self.props.account != null &&
            marketItems[i]["sellerAddress"].toLowerCase() === self.props.account.address.toLowerCase()
          ) {
            isForUser = true;
          }
          marketItems.splice(i, 1);
          break;
        }
      }
      if(isForUser) {
        self.setState({
          marketItems,
          transactionStatus: "Delist Complete",
        });
      } else {
        self.setState({
          marketItems,
        });
      }
    }).on("error", function(event) {
      self.setState({
        transactionStatus: "Failed",
      });
    });

    ppvContract.events.MarketItemUpdated().on("data", function(event) {
      let data = event.returnValues;
      let isForUser = false;
      for(let i = 0; i < marketItems.length; i++) {
        if(parseInt(marketItems[i]["marketItemId"]) === parseInt(data["marketItemId"])) {
          if(
            self.props.account != null &&
            marketItems[i]["sellerAddress"].toLowerCase() === self.props.account.address.toLowerCase() &&
            marketItems[i]["protocol"] === "the402"
          ) {
            isForUser = true;
          }
          marketItems[i]["price"] = data["newPrice"];
          break;
        }
      }
      if(isForUser) {
        self.setState({
          marketItems,
          transactionStatus: "Price Update Complete",
        });
      } else {
        self.setState({
          marketItems,
        });
      }
    }).on("error", function(event) {
      self.setState({
        transactionStatus: "Failed",
      });
    });
    bondingCurveContract.events.MarketItemUpdated().on("data", function(event) {
      let data = event.returnValues;
      let isForUser = false;
      for(let i = 0; i < marketItems.length; i++) {
        if(parseInt(marketItems[i]["marketItemId"]) === parseInt(data["marketItemId"])) {
          if(
            self.props.account != null &&
            marketItems[i]["sellerAddress"].toLowerCase() === self.props.account.address.toLowerCase() &&
            marketItems[i]["protocol"] === "liquid"
          ) {
            isForUser = true;
          }
          marketItems[i]["price"] = data["newPrice"];
          break;
        }
      }
      if(isForUser) {
        self.setState({
          marketItems,
          transactionStatus: "Price Update Complete",
        });
      } else {
        self.setState({
          marketItems,
        });
      }
    }).on("error", function(event) {
      self.setState({
        transactionStatus: "Failed",
      });
    });

    if(this.props.account != null) {
      await this.getHeldAndListedNFTs();
    }
    loggingUtils.logEvent(
      this.props.account != null ? this.props.account.address : encryptUtils.getWalletUnconnectedUserId(),
      'my_nfts',
      'my_nfts_page_load',
      'info',
      "https://the402.xyz",
      {},
    );
  }

  async componentDidUpdate(prevProps) {
    if(prevProps !== this.props && this.props.account == null) {
      this.setState({
        heldNFTs: [],
        currentlyListedNFTs: [],
      });
    } else if(prevProps !== this.props && this.props.account != null) {
      await this.getHeldAndListedNFTs();
    }
  }

  render() {
    return(
      <div className="flex min-h-screen">
        <PlatformSidebar
          modalShown={this.state.modalShown}
          selectModal={this.selectModal}
        />
        <TransactionStatus transactionStatus={this.state.transactionStatus} />
        {
          this.state.modalShown === 'createAccount'
            ?
          <Onboarding selectModal={this.selectModal} />
            :
          this.state.modalShown === 'addFunds'
            ?
          <AddFunds selectModal={this.selectModal} />
            :
          this.state.modalShown === 'importFromPassword'
            ?
          <ImportFromPassword selectModal={this.selectModal} />
            :
          null
        }

        <div className="flex mt-16 flex-col w-full">
          <Profile account={this.props.account} />
          <div className="flex w-screen justify-center">
            <div
              className={
                this.state.isShowingUnlistedTab
                  ?
                "text-lg cursor-pointer text-zinc-500 dark:text-zinc-400 dark:text-white p-4"
                  :
                "text-lg cursor-pointer text-zinc-700 dark:text-zinc-300 p-4 font-semibold"
              }
              onClick={
                () => {
                  loggingUtils.logEvent(
                    this.props.account != null ? this.props.account.address : encryptUtils.getWalletUnconnectedUserId(),
                    'my_nfts',
                    'my_nfts_click_listed_tab',
                    'info',
                    "https://the402.xyz",
                    {},
                  );
                  this.setState({
                    isShowingUnlistedTab: false,
                  });
                }
              }
            >
              Listed
            </div>
            <div
              className={
                this.state.isShowingUnlistedTab
                  ?
                "text-lg cursor-pointer text-zinc-700 dark:text-zinc-300 p-4 font-semibold"
                  :
                "text-lg cursor-pointer text-zinc-500 dark:text-zinc-400 dark:text-white p-4"
              }
              onClick={
                () => {
                  loggingUtils.logEvent(
                    this.props.account != null ? this.props.account.address : encryptUtils.getWalletUnconnectedUserId(),
                    'my_nfts',
                    'my_nfts_click_unlisted_tab',
                    'info',
                    "https://the402.xyz",
                    {},
                  );
                  this.setState({
                    isShowingUnlistedTab: true,
                  });
                }
              }
            >
              Unlisted
            </div>
          </div>
          <div className="flex w-screen border-t border-zinc-300 dark:border-zinc-800 p-16 flex-wrap">
            {
              this.props.account != null && this.state.isShowingUnlistedTab
                ?
              this.state.heldNFTs.filter(heldNFT => heldNFT.listableEditions > 0).map((heldNFT, ind) => {
                return (
                  <UnlistedNFT
                    heldNFT={heldNFT}
                    ind={ind}
                    key={ind}
                    account={this.props.account}
                    setTransactionStatus={this.setTransactionStatus}
                  />
                );
              })
                :
              null
            }
            {
              this.props.account != null && !this.state.isShowingUnlistedTab
                ?
              this.state.currentlyListedNFTs.map((listedNFT, ind) => {
                return (
                  <ListedNFT
                    listedNFT={listedNFT}
                    heldNFTs={this.state.heldNFTs}
                    ind={ind}
                    key={ind}
                    account={this.props.account}
                    setTransactionStatus={this.setTransactionStatus}
                  />
                );
              })
                :
              null
            }
          </div>
        </div>
      </div>
    );
  }
}

export default MyNFTs;
